import "./modules/global";
